import { TranscriptSegment } from '../../hooks/useLiveTranscription'

export type LiveTranscriptionProvider = 'deepgram' | 'openai' | 'assemblyai'

export interface AudioDevice {
  deviceId: string
  label: string
}

export interface AudioRecorderValue {
  isRecording: boolean
  mimeType: string | null
  sourceType: RecordingSource | null
  tabStream: MediaStream | null
  visStream: MediaStream | null
  audioContext: AudioContext | null
  recordedFile: File | null
  availableDevices: AudioDevice[]
  selectedDeviceId: string | null
  startMicrophoneRecording: (options?: { isResume?: boolean }) => void
  startTabRecording: (options?: { isResume?: boolean }) => void
  stopRecordingAndUpload: () => void
  discardExistingRecording: () => Promise<void>
  uploadExistingRecording: () => void
  stopRecordingNoUpload: () => void
  switchMicrophone: (deviceId: string) => Promise<void>
  liveTranscriptSegments: TranscriptSegment[]
  liveTranscriptInterimSegment: TranscriptSegment | null
  isLiveTranscriptionConnected: boolean
  liveTranscriptionError: string | null
  selectedLiveTranscriptionProvider: LiveTranscriptionProvider
  setSelectedLiveTranscriptionProvider: (
    provider: LiveTranscriptionProvider,
  ) => void
}

export enum RecordingSource {
  MIC = 'micRecording',
  TAB = 'tabRecording',
}

export interface AudioRecorderProps {
  onRecordingFinished?: (
    blob: Blob,
    source: RecordingSource,
    overrideDuration?: number,
  ) => void
  onRecordingStarted?: (source: RecordingSource) => void
  onError?: (error: RecorderError) => void
  interviewId: string
}

export interface AudioStreamState {
  audioContext: AudioContext | null
  visStream: MediaStream | null
  micStream: MediaStream | null
  tabStream: MediaStream | null
  micSourceNode: MediaStreamAudioSourceNode | null
  tabSourceNode: MediaStreamAudioSourceNode | null
}

export interface RecorderError extends Error {
  type: 'SETUP_ERROR' | 'RECORDING_ERROR' | 'CLEANUP_ERROR'
}
